// One source of truth for how a kids-free session is LABELLED, so the staff sheet, the
// booking summary and the checkout can never drift into describing the same $0.00 line
// three different ways.
//
// Jeremy, 2026-09-18: a bare "2 × Child  $0.00" reads like an error or a bug to both
// staff and guests. The line needs to say WHY it is zero.

/** Short label shown directly under a zeroed child line. Deliberately terse — it sits in
 *  a price breakdown, not a marketing slot. */
export const KIDS_FREE_LABEL = "School holiday deal — kids free";

/** Slightly longer form for surfaces with room to explain the condition. */
export const KIDS_FREE_SUBLABEL = "Morning sessions during the school holidays.";
